export default function ellide(str, len) {
  if (str && str.length > len) {
    return str.substr(0, len - 1).trim() + "...";
  }
  return str;
}
